import { Testable } from '@eventops/chronotrack-ctlive-mui'
import { createLogger } from '../app/logger'
import CheckinSse from '../features/sse/components/CheckinSse'
import CheckinPageWrapper from '../features/checkin/components/CheckinPageWrapper'
import CheckinLocalForage from '../features/localForage/components/CheckinLocalForage'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'CheckinPage',
})

export type CheckinPageProps = {} & Testable

const CheckinPage = (props: CheckinPageProps) => {
  return (
    <>
     <CheckinSse />
     <CheckinLocalForage />
     <CheckinPageWrapper {...props} />
    </>
  )
}

export default CheckinPage
